

import { HorizontalRule as TiptapHorizontalRule } from '@tiptap/extension-horizontal-rule'
import { HorizontalRuleActionButton } from '@/tiptap/extensions/components/ActionButton'

export default TiptapHorizontalRule.extend({
  addOptions() {
    return {
      ...(this.parent ? this.parent() : {}),
      button: ({ editor, t }) => ({
        component: HorizontalRuleActionButton,
        componentProps: {
          editor,
          t,
        },
      }),
    }
  },
})